// src/hooks/useFuzzyMatch.js
import Fuse from 'fuse.js';

/**
 * Filter a list of { id, name } items by fuzzy query.
 * Used as the Autocomplete filterOptions implementation.
 */
export function fuzzySearch(items, query) {
  if (!query) return items;
  const fuse = new Fuse(items, { keys: ['name'], threshold: 0.4, includeScore: false });
  return fuse.search(query).map(({ item }) => item);
}

/**
 * Auto-suggest the best CRM match for each Dentally item.
 * Returns [{ dentallyItem, crmItem, confidence }] where confidence is 0–100.
 */
export function buildMatchSuggestions(dentallyItems, crmItems) {
  const fuse = new Fuse(crmItems, { keys: ['name'], threshold: 0.5, includeScore: true });
  return dentallyItems.map((di) => {
    const results = fuse.search(di.name);
    const best = results[0];
    return {
      dentallyItem: di,
      crmItem: best ? best.item : null,
      confidence: best ? Math.round((1 - best.score) * 100) : 0,
    };
  });
}
